export default "/_next/static/images/caregiver5-1b65d19751a79777a4d120db22a44e3f.png";